import * as React from 'react';

import { cn } from '@ui/lib/utils';
import { Toggle } from './toggle';
import { EyeOff, Eye } from 'lucide-react';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input flex h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  );
}

function PasswordInput({
  hideText,
  showText,
  ...props
}: Omit<React.ComponentProps<'input'>, 'type'> & {
  hideText: string;
  showText: string;
}) {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className="relative">
      <Input type={showPassword ? 'text' : 'password'} {...props} />
      <Toggle
        pressed={showPassword}
        onPressedChange={(pressed) => setShowPassword(pressed as boolean)}
        variant={'icon'}
        aria-label={showPassword ? hideText : showText}
        className="absolute inset-y-0 right-2"
      >
        {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
      </Toggle>
    </div>
  );
}

export { Input, PasswordInput };
